var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('accordion',{staticClass:"col-12 mt-3",attrs:{"hideTitle":true}},[_c('detalhes')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }